import PinField from "react-pin-field";
import { mergeClass } from "../../utils";
import { Loader } from "../Loader";

export const MFAContainer = ({
  children,
  loading,
  className,
}: {
  loading?: boolean;
  className?: string;
  children: React.ReactNode | string;
}) => (
  <div
    className={mergeClass(
      "w-full max-w-[28rem] flex flex-col text-black",
      "gap-4 bg-white py-3 px-8 place-content-center",
      className
    )}
  >
    {loading ? <Loader /> : children}
  </div>
);

export const VerifyPinField = ({
  onComplete,
  onChange,
  validating,
  username,
}: {
  validating?: boolean;
  username?: string;
  onComplete?: (e: string) => void;
  onChange?: (e: string) => void;
}) => {
  return (
    <>
      <div className="flex w-full justify-center">
        <div className="text-center text-sm w-2/3">
          Enter the 6 digit code from the authenticator app registered to{" "}
          {username ? (
            <span className="font-bold">{username}</span>
          ) : (
            `this account`
          )}
        </div>
      </div>
      <div className="w-full text-white text-2xl font-bold flex place-content-center">
        <PinField
          validate="0123456789"
          style={{
            backgroundColor: validating ? "#AAAAAA" : "#777777",
            width: 40,
            height: 50,
            outline: "none",
            textAlign: "center",
            borderRadius: "0.4rem",
            margin: 2,
          }}
          length={6}
          onComplete={(e) => (onComplete ? onComplete(e) : {})}
          onChange={(e) => (onChange ? onChange(e) : {})}
          disabled={validating}
        />
      </div>
    </>
  );
};
